<template>
  <div
    class="tooltip-wrapper"
    @mouseover="showTooltip = true"
    @mouseleave="showTooltip = false"
  >
    <slot></slot>
    <div v-if="showTooltip && text" class="custom-tooltip">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTooltip: false
    }
  }
}
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  white-space: nowrap;
  z-index: 10;
  margin-bottom: 5px;
  opacity: 1;
  transition: opacity 0.3s ease;
}
</style>
